export const scrollToElement = (element: HTMLElement | null, offset: number = 0) => {
  if (element) {
    element.style.scrollMarginTop = `${offset}px`;
    element.scrollIntoView();
  }
};
